import { Box, InputAdornment } from "@mui/material";
import React, { useState } from "react";
import styles from "./vehicleSearchSection.module.scss";
import FormikControl from "../../../../components/formComponents/FormikControl";
import _ from "lodash";
import i18next from "i18next";
import Button from "../../../../components/buttons/Buttons";
import PropTypes from "prop-types";
import FilterComponent from "../FilterComponent/FilterComponent";

const VehicleSearchSection = (props) => {
  const { handleChange, count, isBtnDisabled, searchKeyword } = props;
  
  const searchParams = JSON.parse(localStorage.getItem('vehicleSearchParams'));
  const filter = _.get(searchParams, 'rows', []);
  const searchFilter = _.get(searchParams, 'searchValue', '');
  const [isShowFilterOption, setIsShowFilterOption] = useState(filter.length > 0);  
  const [searchText, setSearchText] = useState(searchFilter);
  
  
  const isFilterEnabled = () => {
    let isFilterActivated = false ;
    const searchParams = JSON.parse(localStorage.getItem('vehicleSearchParams'));
    if (!_.isEmpty(searchParams)) {     
      const filter = _.get(searchParams, 'rows', []);
      if(filter.length > 0){
        isFilterActivated = true;
      }
    }
    return isFilterActivated;
  }
  const isSearchEnabled = () => {
    let isSearchActivated = false;
    const searchParams = JSON.parse(localStorage.getItem('vehicleSearchParams'));
    const searchFilter = _.get(searchParams, 'searchValue', '');
    if (!_.isEmpty(searchParams) && !_.isEmpty(searchFilter)) {
      isSearchActivated = true;
    }
    return isSearchActivated;
  }

  
  return (
    <Box>
      <Box className={styles.searchSectionWrapper} data-testid="VehicleSearchSection">
        <Box className={styles.searchSection}>
          <Box className={styles.inputBtnWrapper}>
            <FormikControl
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <span className={styles.searchIcon}></span>
                  </InputAdornment>
                ),
              }}
              control="textfield"
              type="text"
              hiddenLabel
              id="filled-hidden-label-small"
              name="search"
              variant="filled"
              size="small"
              placeholder={i18next.t("Search by License, Dealer, Adv. status")}
              className={`input-grp__box ${styles.searchInput}`}
              onChange={(e) => setSearchText(e.target?.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === 'enter') {
                  handleChange(searchText, [])
                }
              }}
              value={searchText}
            />
            <Button
              title={"Search"}
              iconStyle={styles.Back}
              buttonType="muibtn-secondary-with-border"
              attriType={"button"}
              withIcon={true}
              classList={isSearchEnabled() ? styles.filterButton: ''}
              handleClick={() => {
                handleChange(searchText, []);
                setIsShowFilterOption(false);
              }}
              isDisabled={isBtnDisabled}
            />
            <Box sx={{ display: "block" }}>
              <Button
                title={"Filter"}
                iconStyle={styles.Back}
                buttonType="muibtn-secondary-with-border"
                attriType={"button"}
                classList={isFilterEnabled() ? styles.filterButton: ''}
                withIcon={true}
                handleClick={() => {
                  setIsShowFilterOption(!isShowFilterOption);
                  setSearchText("");
                }}                
              />
            </Box>
            <Box>
              <Button
                title={"Clear Search"}
                iconStyle={styles.Back}
                buttonType="muibtn-secondary"
                attriType={"button"}
                withIcon={true}
                handleClick={() => {
                  window.location.reload();
                  localStorage.removeItem('vehicleSearchParams');
                }}                
              />
            </Box>
          </Box>

          {!_.isNull(count) ? (
            <span className={styles.resultCount}>
              {i18next.t("No. results are found", {
                count: count,
              })}
            </span>
          ) : (
            ""
          )}
        </Box>
        <Box className={styles.note}>
          {i18next.t("Select minimum 1 items for bulk actions")}
        </Box>

      </Box>
      <Box>
        {isShowFilterOption ? <FilterComponent setIsShowFilterOption={setIsShowFilterOption} setFilterSearchValues ={handleChange} appliedfilter={searchParams}/> : ""}
      </Box>
    </Box>
  );
};
export default VehicleSearchSection;
VehicleSearchSection.propTypes = {
  handleChange: PropTypes.any,
  count: PropTypes.any,
  isBtnDisabled: PropTypes.any,
  searchKeyword: PropTypes.any
}